module.exports = __webpack_public_path__ + "img/iq.cfc83e3.webp";